import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {

  private isLoading = new BehaviorSubject<boolean>(false);

  public show(): void {
    this.isLoading.next(true);
  }

  public hide(): void {
    this.isLoading.next(false);
  }

  public getIsLoading(): Observable<boolean> {
    return this.isLoading.asObservable();
  }
}
